<template>
    <div style="display: flex; flex-direction: row;">
        <div v-if="menuFeaturedConfig && menuFeaturedConfig.length>0" style="display: flex; flex-direction: row;">
            <v-btn v-for="(item, index) in menuFeaturedConfig" :key="index" color="primary" dark text @click="onOptionClick(item)" style="margin-right: 8px; margin-bottom: 8px;">
                <v-icon v-if="item.icon" small class="mr-2">{{ item.icon }}</v-icon>{{ st(item.label) }}
            </v-btn>
        </div>
    <v-menu offset-y left :close-on-click="true" v-if="menuConfig && menuConfig.length>0">
        <template v-slot:activator="{ on, attrs }">
        <v-btn  color="primary" dark v-bind="attrs" v-on="on" text>
            <span v-if="!compact">{{ $t('wkt.admin.em.header.action-menu') }}</span>
            <v-icon small class="mr-0">{{compact?'more_vert':'expand_more'}}</v-icon>
        </v-btn>
        </template>
        <v-list>
        <v-list-item
            v-for="(item, index) in menuConfig" :key="index">
            <v-list-item-title @click="onOptionClick(item)" style="cursor: pointer;"> 
                    <v-icon v-if="item.icon" small class="mr-2">{{ item.icon }}</v-icon>{{ st(item.label) }}
            </v-list-item-title>
        </v-list-item>
        </v-list>
    </v-menu>
    </div>
</template>
 
 <script> 
 import BaseModule from '../../common/BaseModule.js'

 export default {
   name: 'MenuPanel',
   props: ['config','context','compact'],
   mixins: [BaseModule],
   data() {
       return {
            menuFeaturedConfig: [],
            menuConfig: [],
            menuContext: {},
       }
   },
    mounted() {
        this.menuConfig = this.config.menu;
        this.menuContext= this.context;
    },watch: {
       context: function(context) { 
        this.menuContext=context;
      },
      config: function(config) { 
        this.menuConfig = config.menu.filter(item => !item.featured);
        this.menuFeaturedConfig = config.menu.filter(item => item.featured);
    }
     },
    methods: {
        onOptionClick(item) {
            let payload = { mode:item.mode,type:item.type, action:item.action, payload:item.payload?(this.menuContext[item.payload]?this.menuContext[item.payload]:item.payload):null}
            this.$emit ('menu-selected',payload);
        }
    }
 };
 </script>
  